const buildRentalPortfolioUrl = (host) => `${host ||
    'www.kiavi.com'}/rental-portfolio-sign-up?utm_source=HubSpot&utm_medium=Website&utm_campaign=Hubspot_MFlow_Direct_Lead&utm_content=2024_EG_WM_Portfolio_Product&m_mdm=Website&m_src=HubSpot&m_cpn=Hubspot_MFlow_Direct_Lead&m_prd=Direct&m_ct=html&m_t=Website-Module&m_cta=Next`;

export default buildRentalPortfolioUrl;
